// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nackle-tile {
  border-radius: 24px;
  box-shadow: 0px 8px 32px 0px #34383F14;
}
.nackle-tile-single {
  width: 320px;
  height: 320px;
  container-name: nackle-tile-single;
  container-type: size;
  margin-bottom: 32px;
  display: inline-block;
  overflow: hidden;
}
.nackle-tile-single-infinity {
  width: 320px;
  height: auto;
  container-name: nackle-tile-single-infinity;
  container-type: inline-size;
  margin-bottom: 32px;
  overflow: hidden;
}
.nackle-tile-double {
  width: 672px;
  height: 320px;
  container-name: nackle-tile-double;
  container-type: size;
  margin-right: 32px;
  margin-bottom: 32px;
  overflow: hidden;
}
.nackle-tile-double-infinity {
  width: 672px;
  height: auto;
  container-name: nackle-tile-double-infinity;
  container-type: inline-size;
  margin-right: 32px;
  margin-bottom: 32px;
}
.nackle-tile-triple {
  width: 1024px;
  height: 320px;
  container-name: nackle-tile-triple;
  container-type: size;
  margin-bottom: 32px;
  overflow: hidden;
}
.nackle-tile-triple-infinity {
  width: 1024px;
  height: auto;
  container-name: nackle-tile-triple-infinity;
  container-type: inline-size;
  margin-bottom: 32px;
}
@media screen and (max-width: 1087px) {
  .nackle-tile-double {
    width: 320px;
  }
  .nackle-tile-double-infinity {
    margin-right: 0;
  }
  .nackle-tile-triple {
    width: 672px;
  }
  .nackle-tile-triple-infinity {
    width: 672px;
  }
  .nackle-tile-single {
    display: block;
  }
}
@media screen and (max-width: 735px) {
  .nackle-tile-double-infinity {
    width: 320px;
    margin-right: 0;
  }
  .nackle-tile-triple {
    width: 320px;
    margin-right: 0;
  }
  .nackle-tile-triple-infinity {
    width: 320px;
    margin-right: 0;
  }
}
@media screen and (max-width: 636px) {
  .nackle-tile-double {
    margin-right: 0;
  }
  .nackle-tile-triple {
    margin-right: 0;
  }
  .nackle-tile-double-infinity {
    margin-right: 0;
  }
  .nackle-tile-triple-infinity {
    margin-right: 0;
  }
  .nackle-tile-single {
    margin-right: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/exports/NackleTile/nackle-tile.less"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,sCAAA;AACJ;AAEA;EACI,YAAA;EACA,aAAA;EACA,kCAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AAAJ;AAGA;EACI,YAAA;EACA,YAAA;EACA,2CAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;AADJ;AAIA;EACI,YAAA;EACA,aAAA;EACA,kCAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAFJ;AAKA;EACI,YAAA;EACA,YAAA;EACA,2CAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;AAHJ;AAMA;EACI,aAAA;EACA,aAAA;EACA,kCAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AAJJ;AAOA;EACI,aAAA;EACA,YAAA;EACA,2CAAA;EACA,2BAAA;EACA,mBAAA;AALJ;AAQA;EACI;IACI,YAAA;EANN;EASE;IACI,eAAA;EAPN;EAUE;IACI,YAAA;EARN;EAWE;IACI,YAAA;EATN;EAYE;IACI,cAAA;EAVN;AACF;AAcA;EACI;IACI,YAAA;IACA,eAAA;EAZN;EAeE;IACI,YAAA;IACA,eAAA;EAbN;EAgBE;IACI,YAAA;IACA,eAAA;EAdN;AACF;AAiBA;EACI;IACI,eAAA;EAfN;EAkBE;IACI,eAAA;EAhBN;EAmBE;IACI,eAAA;EAjBN;EAoBE;IACI,eAAA;EAlBN;EAqBE;IACI,eAAA;EAnBN;AACF","sourcesContent":[".nackle-tile {\n    border-radius: 24px;\n    box-shadow: 0px 8px 32px 0px #34383F14;\n}\n\n.nackle-tile-single {\n    width: 320px;\n    height: 320px;\n    container-name: nackle-tile-single;\n    container-type: size;\n    margin-bottom: 32px;\n    display: inline-block;\n    overflow: hidden;\n}\n\n.nackle-tile-single-infinity {\n    width: 320px;\n    height: auto;\n    container-name: nackle-tile-single-infinity;\n    container-type: inline-size;\n    margin-bottom: 32px;\n    overflow: hidden;\n}\n\n.nackle-tile-double {\n    width: 672px;\n    height: 320px;\n    container-name: nackle-tile-double;\n    container-type: size;\n    margin-right: 32px;\n    margin-bottom: 32px;\n    overflow: hidden;\n}\n\n.nackle-tile-double-infinity {\n    width: 672px;\n    height: auto;\n    container-name: nackle-tile-double-infinity;\n    container-type: inline-size;\n    margin-right: 32px;\n    margin-bottom: 32px;\n}\n\n.nackle-tile-triple {\n    width: 1024px;\n    height: 320px;\n    container-name: nackle-tile-triple;\n    container-type: size;\n    margin-bottom: 32px;\n    overflow: hidden;\n}\n\n.nackle-tile-triple-infinity {\n    width: 1024px;\n    height: auto;\n    container-name: nackle-tile-triple-infinity;\n    container-type: inline-size;\n    margin-bottom: 32px;\n}\n\n@media screen and (max-width: 1087px) {\n    .nackle-tile-double {\n        width: 320px;\n    }\n\n    .nackle-tile-double-infinity {\n        margin-right: 0;\n    }\n\n    .nackle-tile-triple {\n        width: 672px;\n    }\n\n    .nackle-tile-triple-infinity {\n        width: 672px;\n    }\n\n    .nackle-tile-single {\n        display: block;\n    }\n\n}\n\n@media screen and (max-width: 735px) {\n    .nackle-tile-double-infinity {\n        width: 320px;\n        margin-right: 0;\n    }\n\n    .nackle-tile-triple {\n        width: 320px;\n        margin-right: 0;\n    }\n\n    .nackle-tile-triple-infinity {\n        width: 320px;\n        margin-right: 0;\n    }\n}\n\n@media screen and (max-width: 636px) {\n    .nackle-tile-double {\n        margin-right: 0;\n    }\n\n    .nackle-tile-triple {\n        margin-right: 0;\n    }\n\n    .nackle-tile-double-infinity {\n        margin-right: 0;\n    }\n\n    .nackle-tile-triple-infinity {\n        margin-right: 0;\n    }\n\n    .nackle-tile-single {\n        margin-right: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
